import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import Link from "next/link"
import { Button, FormGroup, InputGroup } from "@blueprintjs/core"
import Container from "../../common/ui/container"
import { preventDefault } from "../../common/ui/util"
import SendConfirmationEmail from "../use-cases/send-confirmation-email"
import * as _ from "lodash/fp"
import { withContext } from "../../common/framework/context"
import { ApiContext } from "../../common/framework/api-context"
import { ToasterContext } from "../../common/ui/toaster"

const ConfirmEmailForm = ({ error, toaster, onSubmit }) => {
  const [fields, setFields] = useState({ email: "" })
  const setField = (evt) =>
    setFields({ ...fields, [evt.target.name]: evt.target.value })

  useEffect(() => {
    if (error) {
      toaster.show({
        message: error.email,
        intent: "warning",
        icon: "warning-sign",
      })
    }
  }, [error])

  return (
    <form
      className="confirm-email-form"
      onSubmit={preventDefault(() => onSubmit(fields))}
    >
      <FormGroup label="Email">
        <InputGroup
          name="email"
          type="email"
          value={fields.email}
          onChange={setField}
        />
      </FormGroup>
      <Button intent="primary" type="submit">
        Resend Confirmation Email
      </Button>
    </form>
  )
}

const mapStateToProps = (state) => ({
  error: state.login.error,
})

const mapDispatchToProps = (dispatch, { api }) => ({
  onSubmit: SendConfirmationEmail(api.sendConfirmationEmail, dispatch),
})

const ConfirmEmailFormContainer = _.compose(
  withContext(ApiContext, "api"),
  withContext(ToasterContext, "toaster"),
  connect(mapStateToProps, mapDispatchToProps)
)(ConfirmEmailForm)

const ConfirmationEmailSender = () => (
  <Container>
    <h2>Send Confirmation Email</h2>
    <ConfirmEmailFormContainer />
    <div>
      <Link href="/auth/login">Login</Link>
      {" or "}
      <Link href="/auth/register">Register</Link>
    </div>
  </Container>
)

export default ConfirmationEmailSender
